import request from '@/helpers/request'
import Vue from 'vue'

export default {
  GET_STORES({ commit }, payload) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.stores.all}`, {
      params: payload && payload.params ? payload.params : {},
    }).then(res => {
      commit('SET_STORES', res.data.data.items)
    })
  },
}
